import { render, staticRenderFns } from "./NewsletterComponent.vue?vue&type=template&id=2fc6cd16&"
import script from "./NewsletterComponent.vue?vue&type=script&lang=js&"
export * from "./NewsletterComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports